import React from "react";
import { ReactComponent as CreateFolderIcon } from "icons/tasks/create-folder.svg";
import { ReactComponent as CompareDocumentsIcon } from "icons/tasks/compare-documents.svg";
import { ReactComponent as CompareExcelIcon } from "icons/tasks/compare-excel.svg";
import { ReactComponent as SimpleShredIcon } from "icons/tasks/simple-shred.svg";
import { ReactComponent as CategoryShredIcon } from "icons/tasks/category-shred.svg";
import { ReactComponent as DictionarySearchIcon } from "icons/tasks/dictionary-search.svg";
import { ReactComponent as DiscoveryIcon } from "icons/tasks/discovery.svg";
import { ReactComponent as ExtractAcronymsIcon } from "icons/tasks/extract-acronyms.svg";
import { ReactComponent as UploadDocumentsIcon } from "icons/tasks/upload-documents.svg";
import { ReactComponent as ViewReadabilityScoresIcon } from "icons/tasks/view-readability-scores.svg";
import { exportOrigin } from "layout/dictionarySearch/constants";
import { matrixAction, resetExtTreeModel } from "components/Task/helpers";

export const taskTypes = {
  createFolder: "create-folder",
  uploadDocuments: "upload-documents",
  discovery: "discovery",
  dictionarySearch: "dictionary-search",
  simpleShred: "simple-shred",
  viewReadabilityScores: "view-readability-scores",
  compareExcel: "compare-excel",
  compareDocuments: "compare-documents",
  extractAcronyms: "extract-acronyms",
  categoryShred: "category-shred",
};

export const taskConfigs = {
  [taskTypes.createFolder]: {
    title: "Create Folder",
    description: "Use folders to group related documents",
    icon: <CreateFolderIcon />,
    buttonTitle: "Create folder",
    onClick: () => {
      window.Application.DocSetNavView.prototype.createFolder();
    },
  },

  [taskTypes.uploadDocuments]: {
    title: "Upload Documents",
    description:
      'Drop files here or click "Browse your files" to upload documents',
    icon: <UploadDocumentsIcon />,
    buttonTitle: "Browse your files",
    onClick: (args) => {
      if (args === undefined || args.docSetId === undefined) {
        resetExtTreeModel();
      }
      window.Ext.getCmp("docSetNavView").newDoc();
    },
  },

  [taskTypes.discovery]: {
    title: "Discovery",
    description: "Use AI to see themes across docs. Use for gap analysis",
    icon: <DiscoveryIcon />,
    buttonTitle: "View",
    onClick: (args) => {
      window.Application.common.drillInto(1, args.docSetId, args.docId);
    },
  },

  [taskTypes.dictionarySearch]: {
    title: "Dictionary Search",
    description:
      "Power search across docs, check technical terms, contract terms etc.",
    icon: <DictionarySearchIcon />,
    buttonTitle: "View",
    onClick: (args) => {
      window.Application.common.drillInto(2, args.docSetId, args.docId);
    },
  },

  [taskTypes.simpleShred]: {
    title: "Simple Shred",
    description:
      "Shred a doc into Excel. Use to create a Requirements Compliance Matrix",
    icon: <SimpleShredIcon />,
    buttonTitle: "Shred",
    onClick: (args) => {
      matrixAction(args.docSetId, args.docId, exportOrigin.simpleShred);
    },
  },

  [taskTypes.viewReadabilityScores]: {
    title: "View Readability Scores",
    description: "Measuring text complexity for ease of understanding",
    icon: <ViewReadabilityScoresIcon />,
    buttonTitle: "View",
    onClick: (args) => {
      window.Application.common.drillInto(3, args.docSetId, args.docId);
    },
  },

  [taskTypes.compareExcel]: {
    title: "Compare Excel",
    description: "Compare two Excel workbooks, identifying any changes",
    icon: <CompareExcelIcon />,
    buttonTitle: "Compare",
    onClick: () => {
      window.Ext.getCmp("docSetNavView").compareExcel();
    },
  },

  [taskTypes.compareDocuments]: {
    title: "Compare Documents",
    description: "Analyzing documents for similarities and differences",
    icon: <CompareDocumentsIcon />,
    buttonTitle: "Compare",
    onClick: () => {
      window.Ext.getCmp("docSetNavView").compareDocs();
    },
  },

  [taskTypes.extractAcronyms]: {
    title: "Extract Acronyms",
    description: "Identify non-defined acronyms, conflicting acronyms etc.",
    icon: <ExtractAcronymsIcon />,
    buttonTitle: "Extract",
    onClick: (args) => {
      if (args !== undefined && args.docId !== undefined) {
        window.Ext.getCmp("docSetNavView").showAcronyms(
          args.docSetId,
          args.docId
        );
      } else {
        window.Ext.getCmp("docSetNavView").acronymsMultipleDocs();
      }
    },
  },

  [taskTypes.categoryShred]: {
    title: "Category Shred",
    description: "Support reviews by different roles or subject matter experts",
    icon: <CategoryShredIcon />,
    buttonTitle: "Shred",
    onClick: (args) => {
      matrixAction(args.docSetId, args.docId, exportOrigin.catShred);
    },
  },
};

export const getContentClasses = (taskType, args) => {
  let classes = "";

  if (taskType === taskTypes.uploadDocuments) {
    classes = "upload-documents";

    if (args !== undefined && args.chooseFolder === true) {
      classes += " choose-folder";
    }
  }

  return classes;
};
